import { RootState } from '../root';

export const selectNotificationMessage = (state: RootState) =>
    state.ui.notification;
